import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  signal,
} from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';
import { environment } from '@env/environment';
import { SelectedLanguageService } from '@shared/service/selected-language.service';
import { LOADING_LOGIN_TRANSLATIONS } from './loading-login-translations.const';
import { EntraAuthService } from '@core/services/entra-auth.service';

@Component({
  selector: 'app-loading-login',
  standalone: true,
  imports: [LucideAngularModule],
  templateUrl: './loading-login.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingLoginComponent {
  private readonly selectedLanguageService = inject(SelectedLanguageService);
  protected readonly entraAuthService = inject(EntraAuthService);

  readonly title = environment.portalTitle;
  private readonly translations = LOADING_LOGIN_TRANSLATIONS;

  private readonly currentLanguage = signal(
    this.selectedLanguageService.getStoredLanguage().value
  );

  protected readonly t = computed(
    () => this.translations[this.currentLanguage()]
  );

  protected triggerPopupLogin(): void {
    this.entraAuthService.triggerIframeLogin();
  }
}
